export const verifiedEmailSelector = (state: any) =>
  state?.getVerifiedEmail || "";
